<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="rabbitMQServers"
      :items="rabbitMQServers"
      :fields="rabbitMQServersFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedRabbitMQServer"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      rabbitMQServersFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'host', label: this.$i18n.t('Host'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'exchange', label: this.$i18n.t('Exchange'), sortable: true},
        {key: 'routing_key', label: this.$i18n.t('Routing key'), sortable: true},
        {key: 'queue', label: this.$i18n.t('Queue'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedRabbitMQServer: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedRabbitMQServer = {
        id: 0,
        host: '127.0.0.1',
        port: 5672,
        exchange: 'my-exchange',
        queue: 'my-queue',
        routing_key: 'my-routing-key',
        login: 'guest',
        password: 'guest',
        name: 'My RabbitMQ server'
      }
      this.$root.$emit('bv::show::modal', 'modalEditRabbitMQServer', '#btnShow')
    },
    editItem (item) {
      this.selectedRabbitMQServer = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditRabbitMQServer', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "RabbitMQ server"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_RABBIT_MQ_SERVERS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RABBIT_MQ_SERVERS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    rabbitMQServers () {
      return this.$store.getters['Settings/RABBIT_MQ_SERVERS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_RABBIT_MQ_SERVERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/rabbitMQ/main.vue